import { render, staticRenderFns } from "./Subsidios.vue?vue&type=template&id=05722fea&"
import script from "./Subsidios.vue?vue&type=script&lang=js&"
export * from "./Subsidios.vue?vue&type=script&lang=js&"
import style0 from "./Subsidios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports